import { PasswordExpiredRequest } from 'api/generated';
import { IdentityService } from 'api/generated/services/IdentityService';
import { UseMutationOptions, useMutation } from 'react-query';

export type IdentityPasswordChangeInInput = {
  userId: number;
  requestBody?: PasswordExpiredRequest;
};

export const useIdentityUsersPasswordChangeMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof IdentityService.postIdentityUsersPasswordChange>>,
      unknown,
      {
        input: IdentityPasswordChangeInInput;
      },
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ input: input }) => IdentityService.postIdentityUsersPasswordChange(input.userId, input.requestBody),
    options
  );
